import React, { Component, useState, Fragment, useEffect, useRef, useMemo } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import GrainIcon from '@mui/icons-material/Grain';
import LightModeIcon from '@mui/icons-material/LightMode';
import Checkbox from '@mui/material/Checkbox';
import ClearIcon from '@material-ui/icons/Clear';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { AppBar, Toolbar, Typography, Button, IconButton, Modal, Grid, Box, TextField, FormControl, Drawer, Menu, Paper, Select, MenuItem, TableFooter, TableRow, TableCell } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Card from '@material-ui/core/Card';
import SearchIcon from '@material-ui/icons/Search';
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EditIcon from '@mui/icons-material/Edit';
import { PostAddOutlined } from '@mui/icons-material';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { customTheme, getColorfont, getColor } from '../../../StyleComponents/Styledatatable';
import classNames from 'classnames';
import ApprovalIcon from '@mui/icons-material/Approval';
import FilterListIcon from '@mui/icons-material/FilterAlt';
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import useStyles from '../../../StyleComponents/StyleFunctionComponent';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Skeleton from '@material-ui/lab/Skeleton';
import LinearProgress from '@mui/material/LinearProgress';
import { API_BASE_URL, token, userLevel, adminId } from '../../../../constants';

const DuplicateLeadReport = () => {
    const history = useHistory();
    const [openSidebar, setOpenSidebar] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [perPage, setPerPage] = useState(50);
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 30);
    const [fromDate, setFromDate] = useState(sevenDaysAgo.toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(currentDate.toISOString().split('T')[0]);
    const [enquirySource, setEnquirySource] = useState([]);
    const [selectedState, setSelectedState] = useState();
    const [stateOptions, setStateOptions] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState();
    const [brandOptions, setBrandOptions] = useState([]);
    const generateYearOptions = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = currentYear; i >= currentYear - 10; i--) {
            years.push({ id: i, title: i.toString() });
        }
        return years;
    };
    const [yearOptions] = useState(generateYearOptions());
    const [selectedYear, setSelectedYear] = useState(() => {
        const years = generateYearOptions();
        return years.find(y => y.id === new Date().getFullYear()) || years[0];
    });
    const [selectedExecutiveId, setSelectedExecutiveId] = useState(null);
    const [executiveOptions, setExecutiveOptions] = useState([]);
    const [sources, setSources] = useState([]);
    const [selectedSource, setSelectedSource] = useState();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
    const [duplicateLoading, setDuplicateLoading] = useState(false);
    const [duplicateData, setDuplicateData] = useState([]);
    const [selectedLead, setSelectedLead] = useState(null);

    const handleDuplicateClick = async (row) => {
        setSelectedLead(row);
        setDuplicateModalOpen(true);
        setDuplicateLoading(true);

        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };

            const payload = {
                mobile: row.mobile,
                tractor_id: row.tractor_id,
                brand_id: row.brand_id,
                start_date: fromDate,
                end_date: toDate,
            };

            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/duplicate-leads`,
                payload,
                config
            );

            setDuplicateData(response.data.data || []);
        } catch (error) {
            console.log(error);
            setDuplicateData([]);
        } finally {
            setDuplicateLoading(false);
        }
    };

    const handleCloseDuplicateModal = () => {
        setDuplicateModalOpen(false);
        setDuplicateData([]);
        setSelectedLead(null);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/webApi/sources`);
                const data = response.data.data;
                setSources(data.map(item => item.enquiry_from));
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    const handleSelectChange = (event) => {
        setSelectedSource(event.target.value);
    };

    useEffect(() => {
        const fetchDatabrand = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/brand-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.brand_id,
                    title: item.brand_name,
                }));
                setBrandOptions(statelist);
            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };
        fetchDatabrand();
    }, []);

    useEffect(() => {
        const fetchDatastate = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/state-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.state_id,
                    title: item.state_name,
                }));
                setStateOptions(statelist);
            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };
        fetchDatastate();
    }, []);

    useEffect(() => {
        const fetchDatalist = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/executive-list`, config);
                const mappedData = response.data.data.map(item => ({
                    id: item.admin_id,
                    title: item.username,
                }));
                setExecutiveOptions(mappedData);
            } catch (error) {
                console.error('Error fetching executives:', error);
            }
        };
        fetchDatalist();
    }, []);

    const handleExecutiveChange = (event) => {
        const selectedId = event.target.value;
        setSelectedExecutiveId(selectedId);
    };
    const handleStateChange = (event, newValue) => {
        setSelectedState(newValue);
    };
    const handleBrandChange = (event, newValue) => {
        setSelectedBrand(newValue);
    };
    const handleYearChange = (event, newValue) => {
        setSelectedYear(newValue);
    };

    const fetchData = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };
            const requestData = {
                brand_id: selectedBrand?.id || '',
                state_id: selectedState?.id || "",
                source: selectedSource || "",
                start_date: fromDate,
                end_date: toDate,
                page: page + 1,
                pagination: perPage,
                search: search
            };
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/duplicates-enquires-report`,
                requestData,
                config
            );
            const apiData = response.data.data;
            const mappedData = response.data.data.data.map((item) => {
                const formattedDate = item.created_at
                    ? new Date(item.created_at).toLocaleString("en-IN", {
                        year: "numeric",
                        month: "short",
                        day: "2-digit",
                        hour12: true,
                    })
                    : "";

                return {
                    // Keep existing keys
                    id: item.id,
                    enquiry_name: item.enquiry_name || "",
                    fullName: `${item.first_name || ""} ${item.last_name || ""}`.trim(),
                    mobile: item.mobile || "",
                    email: "",

                    created_at: formattedDate,

                    tractor_model_name: item.tractor_name || "",
                    brand_name: item.brand_name || "",

                    state_name: "",
                    city_name: "",
                    taluka: "",

                    executive: "",
                    admin_id: "",

                    enquiry_from: item.enquiry_from || "",
                    is_dublicate: item.duplicate_count > 1 ? "Yes" : "No",

                    call_status: "",
                    pincode: "",
                    village: "",
                    land: "",

                    loan_type: "",
                    Purchasedate: formattedDate,

                    exchanged: "",
                    tractor_name: item.tractor_name || "",

                    // Optional (if needed later)
                    tractor_id: item.tractor_id,
                    brand_id: item.brand_id,
                    duplicate_count: item.duplicate_count,
                };
            });

            setData(mappedData);
            setTotalCount(apiData.total);
            setSnackbarMessage(response.data.message[0]);
            setSnackbarOpen(true);
        } catch (error) {
            console.error(error);
            setError("Failed to fetch data");
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, [page, perPage]);

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === 'fromDate') {
            setFromDate(value);
        } else if (name === 'toDate') {
            setToDate(value);
        }
    };
    const handlePerPageChange = (e) => {
        setPerPage(Number(e.target.value));
    };
    const handlePrevious = () => {
        if (page > 0) {
            setPage(page - 1);
        }
    };
    const handleNext = () => {
        setPage(page + 1);
    };
    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setPage(0);
        fetchData();
        setOpenSidebar(false);
    };
    const clearForm = () => {
        setSelectedBrand(null);
        setSelectedState(null);
        setSelectedSource("");
        setSearch("");
        setPage(0);
        fetchData();
    };

    const columns = [
        {
            name: "id",
            label: "S/N",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    align: "center",
                }),
            },
        },
        {
            name: "enquiry_name",
            label: "Enquiry",
        },
        {
            name: "fullName",
            label: "Customer Name",
        },
        {
            name: "mobile",
            label: "Mobile",
        },
        {
            name: "tractor_model_name",
            label: "Tractor Model",
        },
        {
            name: "brand_name",
            label: "Brand",
        },
        {
            name: "enquiry_from",
            label: "Source",
        },

        {
            name: "duplicate_count",
            label: "Duplicate Count",
            options: {
                filter: false,
                sort: true,
                setCellProps: () => ({
                    align: "center",
                }),
                customBodyRenderLite: (dataIndex) => {
                    const row = data[dataIndex];
                    const count = row?.duplicate_count || 0;

                    return (
                        <Button
                            variant="contained"
                            size="small"
                            onClick={() => handleDuplicateClick(row)}
                            style={{
                                backgroundColor: "#FF0000",
                                color: "#fff",
                                minWidth: 70,
                                borderRadius: 10,
                                fontWeight: 600,
                                textTransform: "none",
                            }}
                        >
                            {count}
                        </Button>
                    );
                },
            },
        },

        {
            name: "created_at",
            label: "Created Date",
        },
    ];

    const CustomToolbarAction = ({ toggleFilter }) => (
        <IconButton aria-label="Filter list" onClick={toggleFilter}>
            <FilterListIcon onClick={toggleSidebar} />
        </IconButton>
    );

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.shiftKey && event.key === 'F') {
                setOpenSidebar(true);
            }
        };
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    const toggleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };

    const options = {
        rowsPerPage: perPage,
        selectableRows: 'none',
        page: page,
        serverSide: true,
        count: totalCount,
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPage(tableState.page);
                    break;
                case 'changeRowsPerPage':
                    setPerPage(tableState.rowsPerPage);
                    setPage(0);
                    break;
                default:
                    break;
            }
        },
        customToolbar: () => <CustomToolbarAction />,
        filter: false,
        filterType: "dropdown",
        responsive: "standard",
        fixedHeader: true,
        fixedSelectColumn: true,
        overflowy: "auto",
        overflowx: "auto",
        rowsPerPageOptions: [10, 50, 100, 500, 1000, 10000, { value: totalCount, label: 'All' }],
        customFilterDialogFooter: (currentFilter, applyNewFilter) => (
            <div>
                <TextField
                    label="Filter Data"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                    fullWidth
                />
                <Button onClick={applyNewFilter} variant="contained" color="primary">
                    Apply Filter
                </Button>
                <Button onClick={() => setOpenSidebar(false)} variant="contained" color="secondary">
                    Cancel
                </Button>
            </div>
        ),
    };
    const currentTheme = customTheme(true);
    const classes = useStyles();
    const memoizedData = useMemo(() => data, [data]);
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const duplicateColumns = [
        {
            name: "id",
            label: "ID",
        },
        {
            name: "created_at",
            label: "Created Date",
        },
        {
            name: "enquiry_name",
            label: "Enquiry",
        },
        {
            name: "first_name",
            label: "First Name",
        },
        {
            name: "last_name",
            label: "Last Name",
        },
        {
            name: "mobile",
            label: "Mobile",
        },
        {
            name: "tractor_name",
            label: "Tractor",
        },
        {
            name: "brand_name",
            label: "Brand",
        },
        {
            name: "enquiry_from",
            label: "Source",
        },
    ];

    const duplicateOptions = {
        filter: false,
        search: true,
        download: true,
        print: false,
        viewColumns: true,
        selectableRows: "none",
        responsive: "standard",
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 25, 50, 100],
        elevation: 0,
    };

    return (
        <>
            <div>
                <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <MuiAlert onClose={handleCloseSnackbar} severity="info" sx={{ width: '100%' }}>
                        {snackbarMessage}
                    </MuiAlert>
                </Snackbar>
            </div>
            <Box sx={{ width: '100%' }}>
                <Typography className={classNames(classes.pagetittle, classes.pagetittlestyle)}>
                    Duplicate Lead Report
                </Typography>
                <hr className={classes.horizontalline} />
            </Box>

            <MuiThemeProvider theme={currentTheme}>
                {
                    isLoading ? (
                        <LinearProgress />

                    ) : (
                        ""
                    )
                }

                <MUIDataTable
                    title={
                        isLoading ? (
                            <Skeleton animation="wave" />

                        ) : (
                            <Typography className={classes.tabletittle} >
                                Duplicate Lead Report
                            </Typography>
                        )
                    }
                    data={memoizedData}
                    columns={columns}
                    options={options}
                />
            </MuiThemeProvider>
            <Drawer anchor="right" open={openSidebar}
                PaperProps={{
                    style: {
                        width: "100%",
                        maxWidth: 300,
                        padding: "10px"
                    }
                }}
                onClose={() => setOpenSidebar(false)}
            >
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={4} sm={2} lg={12} style={{ textAlign: "right", cursor: "pointer", }}>
                            <ClearIcon style={{ color: '#c0392b' }} onClick={() => setOpenSidebar(false)} />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={12} >
                            <br />
                            <Typography className={classes.tabletittle} >
                                Filter
                            </Typography>
                        </Grid>
                    </Grid>
                    <div className={classes.root} style={{ paddingRight: "22px", paddingLeft: "22px" }}>
                        <div className={classes.root}>
                            <Grid container spacing={1}>
                                <Grid item xs={4} sm={2} lg={12} >
                                    <input className={classes.inputform} type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />
                                </Grid>
                                <Grid item xs={4} sm={2} lg={12}>
                                    <input className={classes.inputform} type="date" name="toDate" value={toDate} onChange={handleDateChange} />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                    <br />
                    <Grid >
                        <Grid item xs={4} sm={2} lg={12} style={{ margin: "auto", padding: "auto", textAlign: "center" }}>
                            <Button
                                type='submit'
                                style={{ marginRight: "10px" }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ApprovalIcon />}>
                                Apply
                            </Button>
                            <Button
                                type="button" onClick={clearForm}
                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ClearIcon />}>
                                Clear
                            </Button>
                        </Grid>
                    </Grid>
                    <br />
                </form>
            </Drawer >

            <Modal
                open={duplicateModalOpen}
                onClose={handleCloseDuplicateModal}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "95%",
                        maxWidth: 1200,
                        bgcolor: "#f7f8fc",
                        borderRadius: 3,
                        boxShadow: 24,
                        maxHeight: "92vh",
                        overflow: "hidden",
                    }}
                >

                    {/* Header */}

                    <Box
                        sx={{
                            p: 2,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{ fontWeight: 600 }}
                        >
                            Duplicate Leads ({duplicateData.length})
                        </Typography>

                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleCloseDuplicateModal}
                            style={{
                                fontWeight: 600,
                            }}
                        >
                            Close
                        </Button>
                    </Box>

                    {/* Body */}

                    <Box
                        sx={{
                            p: 2,
                            maxHeight: "80vh",
                            overflowY: "auto",
                        }}
                    >

                        {duplicateLoading ? (
                            <LinearProgress />
                        ) : (
                            <MuiThemeProvider theme={currentTheme}>
                                <MUIDataTable
                                    title={""}
                                    data={duplicateData}
                                    columns={duplicateColumns}
                                    options={{
                                        filter: false,
                                        search: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: "none",
                                        pagination: false,
                                        responsive: "standard",
                                        elevation: 0,

                                        fixedHeader: false,

                                        textLabels: {
                                            body: {
                                                noMatch: "No Duplicate Lead Found",
                                            },
                                        },

                                        setTableProps: () => ({
                                            size: "small",
                                        }),

                                        setRowProps: () => ({
                                            style: {
                                                height: 55,
                                            },
                                        }),

                                        setCellProps: () => ({
                                            style: {
                                                paddingTop: 12,
                                                paddingBottom: 12,
                                                paddingLeft: 16,
                                                paddingRight: 16,
                                            },
                                        }),
                                    }}
                                />
                            </MuiThemeProvider>
                        )}

                    </Box>

                </Box>
            </Modal>
        </>
    );
};

export default DuplicateLeadReport;

